import "./src/styles/global.scss"
import emailjs from "emailjs-com"

emailjs.init("user_dbC068SIGHeY4MWoJs6rP")